import { useReactFlow } from '@xyflow/react';
import { useCallback } from 'react';

import { useEditCanvasStore } from '../store';
import { type AppNode } from '../types';

export function useGetSelectedNodes(): () => AppNode[] {
  const { getNodes } = useReactFlow();

  return useCallback(() => {
    const xyFlowNodes = getNodes();
    const canvasNodes = useEditCanvasStore.getState().nodes;
    const selectedIds = new Set(xyFlowNodes.filter((n) => n.selected).map((n) => n.id));

    return canvasNodes.filter((n) => selectedIds.has(n.id));
  }, [getNodes]);
}
